/** Archive-scoped resource fetch 프로토콜 (목록·단일 엔티티 공통) */

export type ResourceScope = 'public' | 'owner';
export type ResourceStatus = 'idle' | 'loading' | 'success' | 'error';

/** owner + scope + success 일 때만 렌더 */
export const canShowScopedResource = ({
  pageOwnerAui,
  resourceOwnerAui,
  resourceScope,
  currentScope,
  status,
}: {
  pageOwnerAui: string | null | undefined;
  resourceOwnerAui: string | null;
  resourceScope: ResourceScope | null;
  currentScope: ResourceScope;
  status: ResourceStatus;
}): boolean =>
  !!pageOwnerAui &&
  resourceOwnerAui === pageOwnerAui &&
  resourceScope === currentScope &&
  status === 'success';

/** scope 없는 owned resource (예: contactPropertyVisible) */
export const canShowOwnedResource = ({
  pageOwnerAui,
  resourceOwnerAui,
  status,
}: {
  pageOwnerAui: string | null | undefined;
  resourceOwnerAui: string | null;
  status: ResourceStatus;
}): boolean =>
  !!pageOwnerAui &&
  resourceOwnerAui === pageOwnerAui &&
  status === 'success';
